import * as React from "react";
import {
  IXGUIFieldBase,
  TOnChange,
} from "../../../utils/interfaces/gui/fields.interfaces";

import { Divider, Stack, TextField, Typography } from "@mui/material";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

const compareProps = (prevProps: any, nextProps: any) => {
  // return isEqual(prevProps, nextProps);
  return prevProps.currentValue === nextProps.currentValue;
};

interface XGUIFontFieldProps extends IXGUIFieldBase {
  onChange: TOnChange<string>;
  currentValue: string;
}

const XGUIFontField: React.FC<XGUIFontFieldProps> = React.memo(
  ({ field, currentValue, onChange }) => {
    const id = `XGUI-FIELD-${field.name}`;
    const bp = useBreakpoint();

    return (
      <React.Fragment>
        <Stack
          className="XGUIField"
          direction="row"
          justifyContent="space-between"
          alignItems={"center"}
          mb={1}
        >
          {/* <AntSwitch
            size="small"
            sx={{ mr: 1 }}
            checked={!disabled}
            onChange={(e) => {
              setDisabled(!e.target.checked);
              debounced(value);
            }}
          /> */}
          <Typography component="label" htmlFor={id} width="40%">
            {field.label}
          </Typography>
          <TextField
            id={id}
            sx={{ ml: 1 }}
            fullWidth
            hiddenLabel
            size="small"
            placeholder={field.placeholder ?? field.label}
            value={currentValue ?? field.defaultValue}
            onChange={(e) => {
              onChange(e.target.value, field.name, bp);
            }}
          />
        </Stack>
        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 1 }} />
      </React.Fragment>
    );
  },
  compareProps
);

export default XGUIFontField;
